import type { IDocumentTable } from '@models/Forms/IForms';

/** ID аналитика уникален только внутри формы. При дублях/отсутствии ID используем путь в полной схеме. */
export function tableColumnSettingsScope(root: object, scope: string): (table: IDocumentTable) => string | undefined {
    const entries: Array<{ table: IDocumentTable; path: string }> = [];
    const visit = (value: unknown, path: string) => {
        if (!value || typeof value !== 'object') return;
        if (Array.isArray(value)) {
            value.forEach((item, index) => visit(item, `${path}/${index}`));
            return;
        }
        const node = value as Record<string, unknown>;
        if (typeof node.key === 'string' && Array.isArray(node.tableColumn)) {
            entries.push({ table: value as IDocumentTable, path });
        }
        for (const [key, child] of Object.entries(node)) visit(child, `${path}/${key}`);
    };
    visit(root, 'form');
    const counts = new Map<string, number>();
    entries.forEach(({ table }) => {
        if (table.id?.trim()) counts.set(table.id, (counts.get(table.id) ?? 0) + 1);
    });
    const keys = new WeakMap<IDocumentTable, string>();
    entries.forEach(({ table, path }) => {
        const locator = table.id?.trim() && counts.get(table.id) === 1 ? ['id', table.id] : ['path', path];
        keys.set(table, JSON.stringify([scope, locator, table.key]));
    });
    return (table) => keys.get(table);
}
